import { PAGE } from "./../constants/page";
import Utility from "./Utility";

export const OIDC_CONFIG = {
  authority: Utility.env?.REACT_APP_KEYCLOAK_URL + "/realms/h",
  client_id: "clinicalpathprimarycare",
  redirect_uri: `${Utility.env?.REACT_APP_URL}` + `${PAGE.GLOBAL_HOME}`,
  automaticSilentRenew: true,
  silent_redirect_uri: `${Utility.env?.REACT_APP_URL}` + `${PAGE.GLOBAL_HOME}`,
  idle_redirect_uri: `${Utility.env?.REACT_APP_URL}` + `${PAGE.IDLESTATE}`,
  mobileIdle_redirect_uri:
    `${Utility.env?.REACT_APP_URL}` + `${PAGE.IDLESTATEMOBILE}`,
  post_logout_redirect_uri:
    `${Utility.env?.REACT_APP_URL}` +
    `${Utility.env?.REACT_APP_LOGOUT_RELATIVE_PATH}`,
  use_pkce_code_challenge: true,
  loadUserInfo: true,
  extraQueryParams: {
    action: "login_activate",
  },
};

export const METADATA_OIDC = {
  token_endpoint: process.env.REACT_APP_AUTH_URL + "/realms/h/connect/token",
  userinfo_endpoint:
    process.env.REACT_APP_AUTH_URL + "/realms/h/connect/userinfo",
  end_session_endpoint:
    process.env.REACT_APP_AUTH_URL + "/realms/h/connect/endsession",
};
